import {createContext, type PropsWithChildren, use, useCallback, useMemo, useState} from 'react'
import {Enforcement} from '../types'

export type EnforcementContext = {
  updateEnforcement: (newEnforcement: Enforcement) => void
  enforcement: Enforcement
}

export const EnforcementContext = createContext<EnforcementContext | undefined>(undefined)

type EnforcementProviderProps = PropsWithChildren

export function EnforcementProvider({children}: EnforcementProviderProps) {
  const [enforcement, setEnforcement] = useState<Enforcement>(Enforcement.Enabled)
  const updateEnforcement = useCallback(
    (newEnforcement: Enforcement) => setEnforcement(newEnforcement),
    [setEnforcement],
  )
  const value = useMemo(
    // eslint-disable-next-line @github-ui/github-monorepo/no-mixed-stability-context-value
    () => ({
      updateEnforcement,
      enforcement,
    }),
    [updateEnforcement, enforcement],
  )

  return <EnforcementContext value={value}>{children}</EnforcementContext>
}

export function useEnforcement() {
  const context = use(EnforcementContext)
  if (!context) {
    throw new Error('useEnforcement must be used within a EnforcementProvider')
  }
  return context
}
